import { FieldCallback, useField } from '@area2k/use-form';
import { useEffect } from 'react';

import FormElement from '@/components/FormElement';
import ItemSelect from '@/components/ItemSelect';
import { Account, Customer, Maybe } from '@/types/graphql';

type Props = {
  label: string;
  fieldId: string;
  customer: Maybe<Customer>;
  accountCallback?: FieldCallback<Account | null>;
};

const AccountSelectField = ({
  label,
  fieldId,
  customer,
  accountCallback,
}: Props) => {
  const { value: account, setValue: setAccount } = useField<Maybe<Account>>(
    fieldId,
    accountCallback
  );

  useEffect(() => {
    setAccount(null);
  }, [customer]);

  return (
    <FormElement htmlFor={`${fieldId}-toggle-button`} label={label}>
      <ItemSelect
        required
        disabled={!customer}
        id={fieldId}
        itemToKey={(item) => item.id}
        itemToString={(item) => (item ? item.name : '')}
        items={customer ? customer.accounts : []}
        placeholder={'Select account'}
        selectedItem={account}
        onSelectedItemChange={({ selectedItem }) =>
          setAccount(selectedItem || null)
        }
      />
    </FormElement>
  );
};

export default AccountSelectField;
